import type { IMaterial } from "./entidades/IMaterial";
import type { IFiltroPaginador, IRespuestaApiLista, IRespuestaApiObjeto } from "../../globales/interfaces";
import api from "../../utils/api";
import type { ITipoMaterial } from "./entidades/ITipoMaterial";

export class MaterialModelo {
    

    constructor() { }
    public async obtenerListaMateriales(filtro: Partial<IMaterial>, paginador: IFiltroPaginador): Promise<IRespuestaApiLista<IMaterial>> {
        const { data } = await api.post(
            `/api/Materiales/ListarPaginado`, {
            ...filtro,
            Id: filtro.Id !== 0 ? filtro.Id : undefined,
            Sku: filtro.Sku !== '' ? filtro.Sku : undefined,
            Nombre: filtro.Nombre !== '' ? filtro.Nombre : undefined,
            TipoMaterialId: filtro.TipoMaterialId !== 0 ? filtro.TipoMaterialId : undefined,
            Page: paginador.Page ? paginador.Page : undefined,
            Size: paginador.Size ? paginador.Size : undefined,
        }, {
            headers: {
                "Content-Type": "application/json",

            },
        });
        return data;
    }

    public async crearMaterial(material: IMaterial): Promise<IRespuestaApiObjeto<IMaterial>> {
        const { data } = await api.post(
            `/api/Materiales/Crear`, material, {
            headers: {
                "Content-Type": "application/json",

            },
        });
        return data;
    }

    public async editarMaterial(material: IMaterial): Promise<IRespuestaApiObjeto<IMaterial>> {
        const { data } = await api.put(
            `/api/Materiales/Actualizar`, material, {
            headers: {
                "Content-Type": "application/json",

            },
        });
        return data;
    }

    public async eliminarMaterial(material: IMaterial): Promise<IRespuestaApiObjeto<boolean>> {
        const { data } = await api.delete(
            `/api/Materiales/Eliminar/${material.Id}`, {
            headers: {
                "Content-Type": "application/json",

            },
        });
        return data;
    }

    public async obtenerListaTipoMaterial(): Promise<IRespuestaApiLista<ITipoMaterial>> {
        const { data } = await api.get(
            `/api/TipoMaterial/Listar`, {
            headers: {
                "Content-Type": "application/json",

            },
        });
        return data;
    }

    public async descargarPlantilla(): Promise<void> {
        const response = await api.get(`/api/Materiales/DescargarPlantilla`, {
            responseType: "blob", // 👈 para recibirlo como archivo
        });

        // Crear un enlace temporal para descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        // Nombre del archivo (puedes obtenerlo del header)
        const disposition = response.headers["content-disposition"];
        let filename = "Plantilla_Material.xlsx";
        if (disposition && disposition.includes("filename=")) {
            const match = disposition.match(/filename\*?=['"]?(?:UTF-8'')?([^;]+)/);
            if (match && match[1]) {
                filename = decodeURIComponent(match[1].replace(/['"]/g, ""));
            }
        }

        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();

        // Liberar URL
        window.URL.revokeObjectURL(url);
    }

    public async cargarMasiva(archivo: File): Promise<IRespuestaApiObjeto<string>> {
        const formData = new FormData();
        formData.append("archivo", archivo);

        const { data } = await api.post(`/api/Materiales/CargarMasiva`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return data;
    }


}

